import { useTranslation } from 'react-i18next'
import { formatCredits } from './billingTypes'

/** A display projection of either typed ledger; financial values stay server-owned. */
export interface CreditHistoryTableRow {
  id: string
  createdAt: string
  action: string
  actionDetail?: string
  credits: number
  balanceAfter?: number
  amountDetail?: string
  testId?: string
}

export default function CreditHistoryTable({ rows }: { rows: readonly CreditHistoryTableRow[] }) {
  const { t, i18n } = useTranslation('settings')
  return <div className="overflow-x-auto rounded-xl border border-border bg-surface-0">
    <table className="w-full text-left text-base">
      <caption className="px-4 py-3 text-left font-medium text-foreground">{t('settingsModal.billing.historyCaption')}</caption>
      <thead className="border-y border-border text-muted-foreground"><tr>
        {['Date', 'Action', 'Amount'].map(column => <th key={column} scope="col" className={`whitespace-nowrap px-4 py-3 font-medium ${column === 'Amount' ? 'text-right' : ''}`}>{t(`settingsModal.billing.history${column}`)}</th>)}
      </tr></thead>
      <tbody>{rows.map(row => <tr key={row.id} data-testid={row.testId} className="border-b border-border-subtle last:border-0">
        <td className="whitespace-nowrap px-4 py-3 text-muted-foreground"><time dateTime={row.createdAt}>{new Date(row.createdAt).toLocaleDateString(i18n.language, { month: 'short', day: 'numeric', year: 'numeric' })}</time></td>
        <td className="px-4 py-3 text-foreground">{row.action}{row.actionDetail !== undefined && <span className="mt-1 block text-sm text-muted-foreground">{row.actionDetail}</span>}</td>
        <td className="whitespace-nowrap px-4 py-3 text-right text-foreground">{row.credits > 0 ? '+' : ''}{formatCredits(row.credits, i18n.language)}
          {row.balanceAfter !== undefined && <span className="mt-1 block font-mono text-sm text-muted-foreground">{t('settingsModal.billing.historyBalance', { credits: formatCredits(row.balanceAfter, i18n.language) })}</span>}
          {row.amountDetail !== undefined && <span className="mt-1 block text-sm text-muted-foreground">{row.amountDetail}</span>}
        </td>
      </tr>)}</tbody>
    </table>
  </div>
}
